export interface ActiveWordTiming {
  startMs?: number;
  endMs?: number;
}

const readMs = (value: number | undefined): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

export const getActiveWordTimingIndex = (
  words: ActiveWordTiming[],
  currentMs: number,
): number | null => {
  if (!Number.isFinite(currentMs)) return null;

  const timedWords = words
    .map((word, index) => ({
      index,
      startMs: readMs(word.startMs),
      endMs: readMs(word.endMs),
    }))
    .filter(
      (word): word is { index: number; startMs: number; endMs: number } =>
        word.startMs !== null && word.endMs !== null,
    )
    .sort((a, b) => a.startMs - b.startMs);

  if (timedWords.length === 0) return null;

  const exactWord = timedWords.find(
    (word) => currentMs >= word.startMs && currentMs <= word.endMs,
  );
  if (exactWord) return exactWord.index;

  for (let index = timedWords.length - 1; index >= 0; index -= 1) {
    const word = timedWords[index];
    if (word && currentMs > word.endMs) {
      return word.index;
    }
  }

  return null;
};
